import request from "../utils/request";
import { getBrowserSessionId } from "./session";

export function login(email, password, recaptchaToken) {
    return request.post("/users/login", {
        email: email,
        password: password,
        recaptchaToken: recaptchaToken,
        browserSessionId: getBrowserSessionId(),
    });
}

export function passwordlessLogin(email, passwordlessLoginToken, recaptchaToken) {
    return request.post(
        "/users/passwordless-login-verify",
        {
            email,
            passwordlessLoginToken,
            recaptchaToken,
            browserSessionId: getBrowserSessionId(),
        },
        { timeout: 60000 }
    );
}

export function forgotPassword(email, recaptchaToken) {
    return request.post("/users/forgot-password", {
        email,
        recaptchaToken,
    });
}

export function passwordlessLoginRequest(email, recaptchaToken) {
    return request.post("/users/passwordless-login", {
        email,
        recaptchaToken,
    });
}

export function resetPassword(password, token, isPasswordless = false, email = "", recaptchaToken) {
    return request.post("/users/reset-password", {
        email,
        password,
        token,
        isPasswordless,
        recaptchaToken,
    });
}

export async function profile() {
    return await request.get("/users/me");
}

export async function adminProfile() {
    return await request.get("/adminUsers/me");
}

export function logout() {
    return request.get("logout");
}
